import { render, staticRenderFns } from "./FormItemLongText.vue?vue&type=template&id=258e2f3a&scoped=true"
import script from "./FormItemLongText.vue?vue&type=script&lang=js"
export * from "./FormItemLongText.vue?vue&type=script&lang=js"
import style0 from "./FormItemLongText.vue?vue&type=style&index=0&id=258e2f3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258e2f3a",
  null
  
)

export default component.exports